import script from "./Counter.vue?vue&type=script&setup=true&lang=js"
export * from "./Counter.vue?vue&type=script&setup=true&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=56b65c34&lang=sass"

const __exports__ = script;

export default __exports__